<template>
  <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbPurple" dark flat>
        <div class="text-h6">{{ $t('general.editNotification') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal(false)">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="validNotification" ref="editNotificationForm" lazy-validation>
          <v-row>
            <v-col cols="12" class="pt-6 pb-0">
              <v-text-field :label="$t('general.name')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="formNotification.name">
              </v-text-field>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-text-field :label="$t('general.code')"
                            color="kbDarkBlue"
                            :rules="[rules.required]"
                            v-model="formNotification.code">
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mr-2"
               color="red"
               outlined
               @click="cancelEdit">{{ $t('general.cancel') }}</v-btn>
        <v-btn color="kbPurple"
               dark
               :loading="editingNotification"
               @click="submit">{{ $t('general.saveChanges') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  data () {
    return {
      editingNotification: false,
      validNotification: false,
      formNotification: {
        name: '',
        code: ''
      },
      rules: rules
    }
  },
  methods: {
    submit () {
      this.editingNotification = true
      this.$store.dispatch('updateNotification', {
        notificationId: this.notification.id,
        name: this.formNotification.name,
        code: this.formNotification.code
      })
        .then(response => {
          this.$refs.editNotificationForm.reset()
          this.editingNotification = false
          notifications.success(this.$t('general.notificationEditedSuccessfully'))
          this.toggleModal(false)
        })
    },
    cancelEdit () {
      this.$refs.editNotificationForm.reset()
      this.$emit('clearSelectedNotification')
      this.$emit('input', false)
    },
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['notification', 'value'],
  watch: {
    notification (value) {
      this.formNotification.name = value.name
      this.formNotification.code = value.code
    }
  }
}
</script>
